// L-ASS.3 FRONT-J2 (K1): redimensiona uma imagem para JPEG mantendo a proporção. NUNCA amplia:
// se o maior lado já for <= maxSide, só recodifica em JPEG. Rejeita se a imagem não decodificar.
export async function resizeImageToJpeg(file: File, maxSide = 1600, quality = 0.8): Promise<Blob> {
  const objectUrl = URL.createObjectURL(file);
  try {
    const img = await new Promise<HTMLImageElement>((resolve, reject) => {
      const el = new Image();
      el.onload = () => resolve(el);
      el.onerror = () => reject(new Error('Imagem inválida ou não decodificável'));
      el.src = objectUrl;
    });

    const width = img.naturalWidth || img.width;
    const height = img.naturalHeight || img.height;
    if (!width || !height) throw new Error('Imagem inválida ou não decodificável');

    const scale = Math.min(1, maxSide / Math.max(width, height));
    const targetWidth = Math.max(1, Math.round(width * scale));
    const targetHeight = Math.max(1, Math.round(height * scale));

    const canvas = document.createElement('canvas');
    canvas.width = targetWidth;
    canvas.height = targetHeight;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Canvas indisponível');
    ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

    const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, 'image/jpeg', quality));
    if (!blob) throw new Error('Falha ao codificar a imagem em JPEG');
    return blob;
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
}
